<template>
    <div v-if="text" class="rich-text" v-html="text" /> <!-- eslint-disable-line vue/no-v-html -->
</template>

<script setup>
defineProps({
    text: {
        type: String,
        required: true,
        default: ''
    }
});
</script>

<style lang="less" src="./RichText.less"></style>
